import "./header.css";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Logo } from "assets/logo";
import { useEffect, useLayoutEffect, useState } from "react";

const navLinkClass = ({ isActive }) => (isActive ? "active" : "");

const SCROLL_THRESHOLD_PX = 12;

const Header = () => {
    const { pathname } = useLocation();
    const isHome = pathname === "/";
    const [scrolled, setScrolled] = useState(false);

    useLayoutEffect(() => {
        setScrolled(window.scrollY > SCROLL_THRESHOLD_PX);
    }, [pathname]);

    useEffect(() => {
        const onScroll = () => {
            setScrolled(window.scrollY > SCROLL_THRESHOLD_PX);
        };
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const heroOverlay = isHome && !scrolled;
    const headerClass = [
        "ln-header",
        heroOverlay ? "ln-header--hero-at-top" : "ln-header--surface",
        scrolled ? "ln-header--scrolled" : ""
    ]
        .filter(Boolean)
        .join(" ");

    useEffect(() => {
        const closeMenus = () => {
            const navbarToggler = document.querySelector(
                ".ln-header .navbar-toggler"
            );
            const navbarCollapse = document.querySelector(
                ".ln-header .navbar-collapse"
            );
            if (navbarToggler) {
                navbarToggler.classList.remove("active");
                navbarToggler.setAttribute("aria-expanded", "false");
            }
            if (navbarCollapse) {
                navbarCollapse.classList.remove("show");
            }
        };

        const scrollEls = document.querySelectorAll(".ln-menu-scroll");
        const autoCloseEls = document.querySelectorAll(".ln-nav-auto-close");
        scrollEls.forEach((el) =>
            el.addEventListener("click", closeMenus)
        );
        autoCloseEls.forEach((el) =>
            el.addEventListener("click", closeMenus)
        );

        const navbarToggler = document.querySelector(
            ".ln-header .navbar-toggler"
        );
        const navbarCollapse = document.querySelector(
            ".ln-header .navbar-collapse"
        );

        let toggleNav;
        if (navbarToggler && navbarCollapse) {
            toggleNav = () => {
                const open = navbarCollapse.classList.toggle("show");
                navbarToggler.classList.toggle("active");
                navbarToggler.setAttribute(
                    "aria-expanded",
                    open ? "true" : "false"
                );
            };
            navbarToggler.addEventListener("click", toggleNav);
        }

        const submenuButtons = document.querySelectorAll(
            ".ln-header .nav-item-has-children"
        );
        const submenuHandlers = [];
        submenuButtons.forEach((elem) => {
            const link = elem.querySelector("a");
            const sub = elem.querySelector(".ln-submenu");
            if (link && sub) {
                const handler = () => sub.classList.toggle("show");
                link.addEventListener("click", handler);
                submenuHandlers.push({ link, handler });
            }
        });

        return () => {
            scrollEls.forEach((el) =>
                el.removeEventListener("click", closeMenus)
            );
            autoCloseEls.forEach((el) =>
                el.removeEventListener("click", closeMenus)
            );
            if (navbarToggler && toggleNav) {
                navbarToggler.removeEventListener("click", toggleNav);
            }
            submenuHandlers.forEach(({ link, handler }) =>
                link.removeEventListener("click", handler)
            );
        };
    }, [pathname]);

    return (
        <header className={headerClass}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <nav
                            className="navbar navbar-expand-lg ln-header__navbar"
                            aria-label="Primary"
                        >
                            <Link
                                className="navbar-brand brand-logo ln-header__brand ln-nav-auto-close"
                                to="/"
                            >
                                <Logo />
                            </Link>
                            <button
                                type="button"
                                className="navbar-toggler"
                                aria-label="Toggle navigation menu"
                                aria-expanded="false"
                                aria-controls="ln-primary-nav"
                            >
                                <span className="toggler-icon" />
                                <span className="toggler-icon" />
                                <span className="toggler-icon" />
                            </button>
                            <div className="navbar-collapse ln-header__collapse">
                                <div
                                    className="ln-header__primary-nav w-100"
                                    id="ln-primary-nav"
                                >
                                    <ul
                                        id="nav"
                                        className="navbar-nav ln-header__link-list align-items-lg-center"
                                    >
                                        <li className="nav-item">
                                            <NavLink
                                                className={navLinkClass}
                                                end
                                                to="/"
                                            >
                                                Home
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                className={navLinkClass}
                                                to="/services"
                                            >
                                                Services
                                            </NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink
                                                className={navLinkClass}
                                                to="/about"
                                            >
                                                About
                                            </NavLink>
                                        </li>
                                    </ul>
                                    <div className="ln-header__cta-desktop d-none d-lg-block">
                                        <Link
                                            className="ln-header-cta ln-nav-auto-close"
                                            to="/contact"
                                        >
                                            Contact us
                                        </Link>
                                    </div>
                                    <div className="d-lg-none px-3 pb-3 pt-1">
                                        <Link
                                            className="ln-header-cta d-block text-center ln-nav-auto-close"
                                            to="/contact"
                                        >
                                            Contact us
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
